import events from '../constants/events';

var externalVideoEventIsSupported = function(eventName) {
   return Object.keys(events.ExternalVideo).some(function(eventKey) {
      return events.ExternalVideo[eventKey] === eventName;
   });
};

export {externalVideoEventIsSupported};
